<script setup lang="ts">
import { FormKitLazyProvider } from '@formkit/vue'
import { ref } from 'vue';
import { HoverCardArrow, HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'radix-vue';
import type { StaticNavigationItem } from '../../types/staticNavigation';

const props = defineProps<{
    staticNavigationItem: StaticNavigationItem;
}>();

const hoverState = ref(false);
const subCategory = computed(() => props.staticNavigationItem.children[0]);
</script>

<template>
    <HoverCardRoot
        v-model:open="hoverState"
        :open-delay="0"
    >
        
<FormKitLazyProvider config-file="true">
<HoverCardTrigger class="flex items-center gap-1.5">
            <FormKitIcon
                icon="chevron-down"
                class="block h-3.5 w-3.5 transition-all duration-150"
                :class="{
                    'rotate-180': hoverState,
                }"
            />
            {{ $t(`global.header.${staticNavigationItem.snippet}`) }}
        </HoverCardTrigger>

        <HoverCardPortal>
            <HoverCardContent
                class="data-[side=bottom]:animate-slideUpAndFade data-[side=right]:animate-slideLeftAndFade data-[side=left]:animate-slideRightAndFade data-[side=top]:animate-slideDownAndFade bg-white z-10 min-w-64 rounded-[1.25rem] border border-neutral-300 px-10 py-5 shadow-md shadow-[#0E1E2F07] data-[state=open]:transition-all"
                :side-offset="5"
            >
                <div class="text-md">
                    <!-- we always have one children as a heading -->
                    <div class="min-h-10 font-bold">
                        <NuxtLink
                            v-if="subCategory.url"
                            :to="subCategory.url"
                        >
                            {{ $t(`global.header.${subCategory?.snippet}`) }}
                        </NuxtLink>
                    </div>

                    <div class="pl-4">
                        <div
                            v-for="category in subCategory.children"
                            :key="category.snippet"
                            class="min-h-10"
                        >
                            <NuxtLink
                                v-if="category.url"
                                :to="category.url"
                            >
                                {{ $t(`global.header.${category.snippet}`) }}
                            </NuxtLink>
                        </div>
                    </div>
                </div>

                <HoverCardArrow
                    class="fill-white"
                    :width="8"
                />
            </HoverCardContent>
        </HoverCardPortal>
</FormKitLazyProvider>

    </HoverCardRoot>
</template>
